/**
 * Auto-generated at build/dev server start by vite version-plugin.
 * .tuMetrics {"tu1": 0.99, "tu2": 0.99, "tu3": 1, "notes": "Embedded bundle build identity", "tuVersion": "2.5"}
 * .help "Build-time constants baked into the JS bundle for stale-client detection."
 */
export const APP_BUILD_META = {
  "buildTime": "2026-11-05T14:56:19.507Z",
  "gitCommit": "9706659b",
  "packageVersion": "0.5.251",
  "releaseSummary": "TeamBots wake tickets 1–3 are live: assign, poller, approval plan.",
  "refreshAnnouncement": "major",
  "releaseNotesVersion": "0.5.251",
  "releaseNotesReleasedAt": "2026-11-05T14:41:00.000Z",
  "releaseNotesCommit": "9486575b"
} as const;
